import React from 'react'
import NavBar from '../navBar/Navbar'
import BoardInput from './BoardInput'

function Board() {
  return (
    <div>
        <NavBar />
        <BoardInput />
    </div>
  )
}

export default Board